import { TFunction } from 'react-i18next'

export const ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png']
const MAX_FILE_BYTE = 10 * 1024 * 1024

/**
 * 画像ファイルのバリデーションとDataURL変換を行う。
 * バリデーション失敗時はアラートを表示して null を返す。
 */
export const readImageFile = (file: File, t: TFunction): Promise<string | null> => {
  if (!ALLOWED_MIME_TYPES.includes(file.type)) {
    window.alert(t('The only image formats that can be used are jpg and png'))
    return Promise.resolve(null)
  }
  if (file.size > MAX_FILE_BYTE) {
    window.alert(t('FileSizeTooLarge'))
    return Promise.resolve(null)
  }
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = (event: ProgressEvent<FileReader>) => {
      const result = event.target?.result ?? null
      resolve(typeof result === 'string' ? result : null)
    }
    reader.onerror = () => {
      // FileReader の読み込みに失敗した場合も必ず Promise を解決する
      resolve(null)
    }
    reader.onabort = () => {
      // ユーザー操作などで読み込みが中断された場合も呼び出し元をハングさせない
      resolve(null)
    }
    reader.readAsDataURL(file)
  })
}
